import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cw-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/error/error.component.ts